// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_COMPARE_STROLLER = "porovnanie ko\u010d\u00edka";
export const STROLLERS_COMPARISON_REMOVE_ALL_CONFIRM = "Naozaj chce\u0161 odobra\u0165 v\u0161etky ko\u010d\u00edky z porovn\u00e1vania?";
